/**
 * General - Represents general display and styling properties for elements.
 * Used to store element descriptions, levels, line styles, weights, classes, templates, and transparency.
 */
export class General {
  /** Element description */
  ElementDescription: string;

  /** Level identifier */
  Level: string;

  /** Line style identifier */
  LineStyle: number;

  /** Line weight/thickness */
  Weight: number;

  /** Class identifier */
  Class: string;

  /** Template identifier */
  Template: string;

  /** Transparency value */
  Transparency: number;

  /**
   * Creates a new General instance
   * @param data - Object containing general properties
   */
  constructor(data: {
    ElementDescription: string;
    Level: string;
    LineStyle: number;
    Weight: number;
    Class: string;
    Template: string;
    Transparency: number;
  }) {
    this.ElementDescription = data.ElementDescription;
    this.Level = data.Level;
    this.LineStyle = data.LineStyle;
    this.Weight = data.Weight;
    this.Class = data.Class;
    this.Template = data.Template;
    this.Transparency = data.Transparency;
  }

  /**
   * Creates a General from a plain object (useful for deserialization)
   * @param obj - Plain object with general data
   * @returns New General instance
   */
  static fromObject(obj: Partial<General>): General {
    return new General({
      ElementDescription: obj.ElementDescription ?? "",
      Level: obj.Level ?? "",
      LineStyle: obj.LineStyle ?? 0,
      Weight: obj.Weight ?? 0,
      Class: obj.Class ?? "",
      Template: obj.Template ?? "",
      Transparency: obj.Transparency ?? 0,
    });
  }

  /**
   * Converts the General to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      ElementDescription: this.ElementDescription,
      Level: this.Level,
      LineStyle: this.LineStyle,
      Weight: this.Weight,
      Class: this.Class,
      Template: this.Template,
      Transparency: this.Transparency,
    };
  }
}


